// 角色權限相關工具函式
import { UserRole } from '../model';

// 路由到角色權限的映射表
interface EditPermissions {
  [key: string]: UserRole[];
}

interface PrintPermissions {
  [key: string]: UserRole[];
}

/**
 * 編輯權限設定
 *
 * 每個路由對應一個角色數組，只有擁有該角色的用戶才能訪問該路由
 * UserRole: 1~4
 */
export const EDIT_PERMISSIONS: EditPermissions = {
  // 會員檔案維護與查詢
  '/membership-master': [1, 2],
  '/membership/detail': [1, 2], // 會員詳情頁面
  '/product-master': [1, 2],
  '/certificate-master': [1, 2],

  // 專業委員會
  '/committee': [1, 2, 3],

  // 活動維護
  '/association-activity': [1, 2, 3],

  // 系統管理設定
  '/admin/users': [1],
  '/admin/permissions': [1],
  '/admin/parameters': [1],
};

/**
 * 編輯權限設定
 *
 * 每個路由對應一個角色數組，只有擁有該角色的用戶才能訪問該路由
 * UserRole: 1~4
 */
export const PRINT_PERMISSIONS: PrintPermissions = {
  // 會員檔案維護與查詢
  '/membership-master': [1, 2, 3],
  '/product-master': [1, 2, 3],
  '/certificate-master': [1, 2, 3],

  // 專業委員會
  '/committee': [1, 2, 3],

  // 活動維護
  '/association-activity': [1, 2, 3],

  // 系統管理設定
  '/admin/users': [1],
  '/admin/permissions': [1],
  '/admin/parameters': [1],
};



export const getEditableRoles = (path: string): UserRole[] => {
  // 精確匹配
  if (EDIT_PERMISSIONS[path]) {
    return EDIT_PERMISSIONS[path];
  }

  // 嘗試前綴匹配
  for (const route in EDIT_PERMISSIONS) {
    if (path.startsWith(route) && route !== '/') {
      return EDIT_PERMISSIONS[route];
    }
  }

  // 默認只有角色1可以訪問
  return [1, 2];
}

export const getPrintableRoles = (path: string): UserRole[] => {
  // 精確匹配
  if (PRINT_PERMISSIONS[path]) {
    return PRINT_PERMISSIONS[path];
  }

  // 嘗試前綴匹配
  for (const route in PRINT_PERMISSIONS) {
    if (path.startsWith(route) && route !== '/') {
      return PRINT_PERMISSIONS[route];
    }
  }

  // 默認只有角色1可以訪問
  return [1, 2, 3];
}

